import wrapRoutesWithAuthorizationCheck from './common/utils/routes/wrapRoutesWithAuthorizationCheck';

import LoginScreen from 'modules/general/authentication/screens/LoginScreen';
import LoginScreenV2 from 'modules/general/authentication/screens/LoginScreenV2';
import CallbackScreen from 'modules/general/authentication/screens/CallbackScreen';
import {
  CREATE_BOOKING_PERMISSION,
  GET_SEATMAP_PERMISSION,
  CREATE_GOSHOW_BOOKING_PERMISSION,
  GET_GOSHOW_BOOKING_FORM_PERMISSION,
  GET_TRANSACTION_LIST_PERMISSION,
  GET_PAX_MANIFEST_LIST_PERMISSION,
  GET_PAX_MANIFEST_DETAIL_PERMISSION,
  GET_USER_PROFILE_PERMISSION,
  READ_TNC_PERMISSION,
} from 'common/constants/authPermissionConstants';
import BusBookingSearchResultScreen from 'modules/bus/booking/search-result/screens/BusBookingSearchResultScreen';
import HomepageScreen from 'modules/general/homepage/screens/HomepageScreen';
import BusBookingSearchFormContainerScreen from 'modules/bus/booking/search-form/screens/BusBookingSearchFormScreen';
import BusGoShowSearchFormContainerScreen from 'modules/bus/go-show/search-form/screens/BusGoShowSearchFormScreen';
import BusTransactionListScreen from 'modules/bus/transaction-list/screens/BusTransactionListScreen';
import BusTransactionDetailScreen from 'modules/bus/transaction-list/screens/BusTransactionDetailScreen';
import BusReservationListSearchScreen from 'modules/bus/transaction-list/screens/BusReservationListSearchScreen';
import BusPaxManifestScreen from 'modules/bus/pax-manifest/search/screens/BusPaxManifestScreen';
import BusPaxManifestDetailScreen from 'modules/bus/pax-manifest/detail/screens/BusPaxManifestDetailScreen';
import AccountInfoScreen from 'modules/general/my-account/account-info/screens/AccountInfoScreen';
import ChangePasswordScreen from 'modules/general/my-account/change-password/screens/ChangePasswordScreen';
import TermsAndConditionScreen from 'modules/general/my-account/terms-and-condition/screens/TermsAndConditionScreen';
import BusPaxManifestCheckerInformationScreen from 'modules/bus/pax-manifest/checker-information/screens/BusPaxManifestCheckerInformationScreen';
import SwitchProvider from 'modules/bus/switch-provider/screens/SwitchProviderScreen';
import BusGoShowBookingFormScreen from 'modules/bus/go-show/booking-form/screens/BusGoShowBookingFormScreen';
import BusBookingFlowScreen from 'modules/bus/booking/booking-flow/screens/BusBookingFlowScreen';
import HelpCenterScreen from 'modules/general/help-center/screens/HelpCenterScreen';
import HelpCenterTopicScreen from 'modules/general/help-center/screens/HelpCenterTopicScreen';
import HelpCenterArticleDetailScreen from 'modules/general/help-center/screens/HelpCenterArticleDetailScreen';
import HelpCenterVideoPlayerScreen from './modules/general/help-center/screens/HelpCenterVideoPlayerScreen';
import HelpCenterSearchScreen from './modules/general/help-center/screens/HelpCenterSearchScreen';
import ForgotPasswordScreen from 'modules/general/authentication/screens/ForgotPasswordScreen.web';
import ResetPasswordScreen from 'modules/general/authentication/screens/ResetPasswordScreen.web';

import { isCognitoEnabled } from 'common/constants/featureFlag';

const authorizedRoutes = wrapRoutesWithAuthorizationCheck({
  // -- HOMEPAGE --
  Home: {
    screen: HomepageScreen,
    path: '',
  },

  // -- ADVANCE BOOKING --
  BusBookingSearchForm: {
    screen: BusBookingSearchFormContainerScreen,
    path: 'bus-booking-search-form',
    permission: [CREATE_BOOKING_PERMISSION],
  },
  BusBookingSearchResult: {
    screen: BusBookingSearchResultScreen,
    path: 'bus-booking-search-result',
    permission: [CREATE_BOOKING_PERMISSION],
  },
  BusBookingFlow: {
    screen: BusBookingFlowScreen,
    path: 'bus-booking-flow',
    permission: [CREATE_BOOKING_PERMISSION, GET_SEATMAP_PERMISSION],
  },

  // -- GO-SHOW BOOKING --
  BusGoShowSearchForm: {
    screen: BusGoShowSearchFormContainerScreen,
    permission: [CREATE_GOSHOW_BOOKING_PERMISSION],
  },
  BusGoShowBookingForm: {
    screen: BusGoShowBookingFormScreen,
    permission: [
      CREATE_GOSHOW_BOOKING_PERMISSION,
      GET_GOSHOW_BOOKING_FORM_PERMISSION,
    ],
  },

  // -- TRANSACTION/RESERVATION LIST --
  BusTransactionList: {
    screen: BusTransactionListScreen,
    permission: [GET_TRANSACTION_LIST_PERMISSION],
  },
  BusTransactionDetail: {
    screen: BusTransactionDetailScreen,
    permission: [GET_TRANSACTION_LIST_PERMISSION],
  },
  BusReservationList: {
    screen: BusReservationListSearchScreen,
    permission: [GET_TRANSACTION_LIST_PERMISSION],
  },

  // -- PAX MANIFEST
  BusPaxManifest: {
    screen: BusPaxManifestScreen,
    permission: [GET_PAX_MANIFEST_LIST_PERMISSION],
  },
  BusPaxManifestDetail: {
    screen: BusPaxManifestDetailScreen,
    permission: [
      GET_PAX_MANIFEST_LIST_PERMISSION,
      GET_PAX_MANIFEST_DETAIL_PERMISSION,
    ],
  },

  // -- MISC PAGES --
  AccountInfo: {
    screen: AccountInfoScreen,
    path: 'account-info',
    permission: [GET_USER_PROFILE_PERMISSION],
  },
  ChangePassword: {
    screen: ChangePasswordScreen,
    path: 'change-password',
    permission: [GET_USER_PROFILE_PERMISSION],
  },
  TermsAndCondition: {
    screen: TermsAndConditionScreen,
    path: 'terms-and-condition',
    permission: [READ_TNC_PERMISSION],
  },
  BusPaxManifestCheckerInformation: {
    screen: BusPaxManifestCheckerInformationScreen,
    permission: [GET_PAX_MANIFEST_DETAIL_PERMISSION],
  },

  // -- HelpCenter pages
  HelpCenter: {
    screen: HelpCenterScreen,
    path: 'help-center',
  },
  HelpCenterTopic: {
    screen: HelpCenterTopicScreen,
    path: 'help-center/topics',
  },
  HelpCenterArticleDetail: {
    screen: HelpCenterArticleDetailScreen,
    path: 'help-center/article-detail',
  },
  HelpCenterVideoPlayer: {
    screen: HelpCenterVideoPlayerScreen,
    path: 'help-center/video-player',
  },
  HelpCenterSearch: {
    screen: HelpCenterSearchScreen,
    path: 'help-center/search',
  },
  SwitchProvider: {
    screen: SwitchProvider,
    navigationOptions: {
      header: null,
    },
    path: 'switch-po',
  },
});

export const mainRoutes = {
  ...authorizedRoutes,
  Login: {
    screen: isCognitoEnabled ? LoginScreenV2 : LoginScreen,
    path: 'login',
  },

  ForgotPassword: {
    screen: ForgotPasswordScreen,
    path: 'forgot-password',
    navigationOptions: {
      header: null,
    },
  },
  ResetPassword: {
    screen: ResetPasswordScreen,
    path: 'reset-password',
    navigationOptions: {
      header: null,
    },
  },
  Callback: {
    screen: CallbackScreen,
    path: 'callback',
  },
};
